/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_COMPLIANCE_DOCS = gql`
  query Orgs(
    $where: OrgWhere
    $options: OrgOptions
    $complianceDocsOptions2: OrgComplianceDocOptions
  ) {
    orgs(where: $where, options: $options) {
      complianceDocs(options: $complianceDocsOptions2) {
        id
        name
        description
        icon
        validFrom
        validUntil
        createdAt
        doc
      }
      complianceDocsAggregate {
        count
      }
    }
  }
`;
